import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import PulseLoader from "react-spinners/PulseLoader";
import InputSettings from "./InputSettings";

export default function InputConfig({ device, pumpRoomRef }) {
  const [inputs, setInputs] = useState([]);
  const [format, setFormat] = useState("digital");
  const [selectedInput, setSelectedInput] = useState();
  const [formatHeading, setFormatHeading] = useState("Digital");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const serverAddress = process.env.REACT_APP_SERVER_ADDRESS;
  const currentUser = useAuth().currentUser;
  const [token, setToken] = useState();
  const [headers, setHeaders] = useState();

  useEffect(() => {
    if (currentUser) {
      currentUser.getIdToken().then((token) => {
        setToken(token);
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (token) {
      setHeaders({
        headers: {
          token: token,
        },
      });
    }
  }, [token]);

  async function getInputs() {
    if (!loading) {
      setLoading(true);
    }
    try {
      const res = await axios.post(
        `${serverAddress}/deviceData/getInputsForWebInputConfig`,
        {
          deviceID: device.id,
          format: format,
        },
        headers
      );
      setInputs(res.data);
    } catch (e) {
      setError("Error getting inputs.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    switch (format) {
      case "digital":
        setFormatHeading("Digital");
        break;
      case "analog":
        setFormatHeading("Analog");
        break;
      case "m3-digital":
        setFormatHeading("M3 Digital");
        break;
      case "m3-analog":
        setFormatHeading("M3 Analog");
        break;
      default:
        setFormatHeading("Digital");
    }
    if (headers) {
      getInputs();
    }
  }, [headers, format]);

  return (
    <div className="max700">
      <div>
        {!selectedInput ? (
          <div className="sectionSpacer">
            <h3>{formatHeading} Inputs</h3>
            <div className="toggle-bar">
              <div
                className={
                  format === "digital" ? "currentToggleItem" : "toggleItem"
                }
                onClick={() => setFormat("digital")}
              >
                Digital
              </div>
              <div
                className={
                  format === "analog" ? "currentToggleItem" : "toggleItem"
                }
                onClick={() => setFormat("analog")}
              >
                Analog
              </div>
              <div
                className={
                  format === "m3-digital" ? "currentToggleItem" : "toggleItem"
                }
                onClick={() => setFormat("m3-digital")}
              >
                M3 Digital
              </div>
              <div
                className={
                  format === "m3-analog" ? "currentToggleItem" : "toggleItem"
                }
                onClick={() => setFormat("m3-analog")}
              >
                M3 Analog
              </div>
            </div>
            <PulseLoader
              color={"#ffffff"}
              loading={loading}
              size={20}
              className="loader"
            />
            {!loading && inputs.length > 0 && (
              <div>
                <div className="listLineTop"></div>
                {inputs.map((i) => (
                  <div key={i.id}>
                    <div
                      className="flex-input-cell"
                      onClick={() => setSelectedInput(i)}
                    >
                      <div className="inputListCell marginlr">{i.inputID}</div>
                      <div className="marginlr">{i.deviceDescription}</div>
                    </div>
                    <div className="listLine"></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="sectionSpacer2">
            <InputSettings
              selectedInput={selectedInput}
              setSelectedInput={setSelectedInput}
              deviceID={device.id}
            />
          </div>
        )}
      </div>
    </div>
  );
}
